export const MANAGE_BLOCKED_TEXT = 'Só a pessoa responsável pela conta ou um administrador pode atualizar o pagamento.';
export const UNDO_CANCEL_BLOCKED_TEXT = 'Só a pessoa responsável pela conta ou um administrador pode desfazer o cancelamento.';
